import { createTheme, responsiveFontSizes, adaptV4Theme, Theme } from '@mui/material/styles';

declare module '@mui/styles' {
  interface DefaultTheme extends Theme {}
}
import { CSSProperties } from 'react';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    white: CSSProperties;
    bold: CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    white?: CSSProperties;
    bold?: CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    white: true;
    bold: true;
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    bright: true;
  }
}
declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsSizeOverrides {
    huge: true;
  }
}

// Main colors
export const morgengrauen = '#ea5436';
export const azurblau = '#5f9ea0';
export const mittelgrau = '#7f8687';
export const lichtgrau = '#e9e9e8';
export const nachtblau = '#2f4253';
export const eisblau = '#c1d2d7';

// Supplementary
export const erfolgreich = '#42bac5';
export const zufrueh = '#fee8a4';
export const zuspaet = '#fece49';
export const zugewiesen = '#c1d2d7';
export const nichtzugewiesen = '#7f8687';
export const unzustellbar = '#ea5436';
export const problem = '#ffa53a';
export const gecancelt = '#272726';

// General
export const white = '#ffffff';
export const black = '#000000';
export const grey = '#808080';
export const check = '#01C853';
export const middlemutedred = '#EF5350';
export const lightblue ='#0288D1';
export const lightgrey ="#eeeeee";

export const background = {
  overlay: 'white', // 'rgba(33, 33, 33, 0.08)',
  grey: {
    high: 'rgba(38, 50, 56, 0.95)',
    medium: 'rgba(38, 50, 56, 0.7)',
    disabled: 'rgba(38, 50, 56, 0.48)'
  },
  tertiary: {
    900: '#263238',
    800: '#37474F',
    700: '#455A64',
    600: '#546E7A',
    500: '#607D8B',
    400: '#78909C',
    300: '#90A4AE',
    200: '#B0BEC5',
    100: '#CFD8DC',
    50: '#ECEFF1'
  }
};

export const palette = {
  orange: {
    500: '#ef5927',
    700: '#d23e13',
    800: '#c3310a'

  },
  blue: {
    500: '#00BCD4',
    600: '#00acc1',
    800: '#00838f'
  }
};

export const dispatch_theme:Theme = createTheme({
  spacing: 8,
  palette: {
    primary: {
      light: palette.orange['700'],
      main: palette.orange['500'],
      dark: palette.orange['800'],
      contrastText: white
    },
    secondary: {
      light: palette.blue['500'],
      main: palette.blue['600'],
      dark: palette.blue['800'],
      contrastText: white
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    contrastThreshold: 4.5,
  },
  typography: {
    fontFamily: 'Roboto',
    white: {
      color: white
    },
    bold: {
      fontWeight: 500
    },
  },
  components: {
    MuiSvgIcon: {
      defaultProps: {
        htmlColor: grey,
      },
      variants: [
        {
          props: { fontSize: 'huge' },
          style: {
            fontSize: '5rem',
          },
        },
        {
          props: { color: 'bright' },
          style: {
            color: white,
          },
        },
      ],
      styleOverrides: {}
    },
  }
});
